import type { TraitEntry } from './types';

const KIND_LABEL: Record<TraitEntry['kind'], string> = {
  virtue: 'Virtue',
  flaw: 'Flaw',
  personality: 'Personality',
};

const KIND_COLOR: Record<TraitEntry['kind'], string> = {
  virtue: 'text-gold-300 border-gold-400/40',
  flaw: 'text-rose-300/90 border-rose-400/30',
  personality: 'text-emerald-300/90 border-emerald-400/30',
};

export function TraitSection({ traits }: { traits: TraitEntry[] }) {
  const groups: Record<TraitEntry['kind'], TraitEntry[]> = {
    virtue: [],
    flaw: [],
    personality: [],
  };
  for (const t of traits) groups[t.kind].push(t);

  return (
    <div className="space-y-4">
      {(Object.keys(groups) as TraitEntry['kind'][]).map((kind) =>
        groups[kind].length === 0 ? null : (
          <section key={kind}>
            <div className="font-display text-[11px] uppercase tracking-[0.28em] text-gold-400 mb-2">
              {KIND_LABEL[kind]}s
            </div>
            <div className="grid gap-2 sm:grid-cols-2">
              {groups[kind].map((t) => (
                <div
                  key={t.slug}
                  className={`rounded-sm border bg-ink-800/40 p-3 ${KIND_COLOR[kind]}`}
                >
                  <div className="font-serif text-sm text-parchment-50">{t.label}</div>
                  <div className="text-xs text-parchment-100/80 mt-1">{t.effect}</div>
                  <div className="text-xs italic muted mt-2">{t.example}</div>
                </div>
              ))}
            </div>
          </section>
        )
      )}
    </div>
  );
}
